import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCallTrackerNumbers as GetCallTrackerNumbersQuery,
    GetCallTrackerNumbers_callTrackerNumbers as CallTrackerNumbers,
} from 'nutshell-graphql-types';

import GET_CALL_TRACKER_NUMBERS from '../queries/get-calltracker-numbers.graphql';

export const useGetCallTrackerNumbers = (): {
    callTrackerNumbers: CallTrackerNumbers[] | null | undefined;
    error: string | undefined;
    isLoading: boolean;
} => {
    const {data, error, loading} = useQuery<GetCallTrackerNumbersQuery, Record<string, never>>(
        GET_CALL_TRACKER_NUMBERS
    );

    return {
        callTrackerNumbers: data && data.callTrackerNumbers,
        // @ts-expect-error - safelyGetGraphQLErrorMessage types
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
